import React, { useEffect ,useContext} from 'react'
import { useQuery, useApolloClient } from '@apollo/client';
import { insertFeedback } from '../../graphql/feedback_queries';
import { findSchemaDefinition } from '@rjsf/utils';
import client from '../apollo';
import AppConfig from '../../utility/AppConfig';
import apiCall from '../../utility/api';

type dataprops={
  formData?:any
  setFormData?:any
  setFormSubmit?:any
  formSubmit?:any
}

export const Feedback_Func = (props: dataprops) => {
  //function consist of mail api call
  const sendMail = async (userEmail:string, action:string, userFeedback:any) => {
    try {
      const response = await apiCall('/sendEmail',{ 'userEmail': userEmail, 'action': action, 'userFeedback': userFeedback }, "POST");
      console.log("Success:", response);
    } catch (error) {
      console.error("sendMail error=", error);
    }
  }

  let expression=props.formData.Expression;
  let experience =props.formData.Experience;
  let contact_me =props.formData.ContactMe;
  let email= props.formData.Email;
  const AddFeedback =async ()=>{
    const dataToSend = {
      expression: expression,
      experience: experience,
      contact_me: contact_me,
      email: email
    };

  let data = await apiCall('/feedback/insertFeedback', dataToSend);
    try{
      if(data.status === 'success'){
        sendMail(email,"feedback",dataToSend);
      }
      } catch (error) {
      console.log("AddFeedback error=",error);
    }
  }

  useEffect(() => {
    props.formSubmit && AddFeedback();
    setTimeout(() => {
      props.setFormSubmit(false);
      props.setFormData({ Experience: '', Expression: '', ContactMe: 'No', Email: '' })
    }, 2000);
  },[props.formSubmit]);

  return (<></>)
}